module.exports = __webpack_public_path__ + "static/img/bank_default.4cb37d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank_default.png
// module id = qNBk
// module chunks = 3